import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahl } from './DatenauswertungJahrauswahl';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { disableKosten } from '../../helpers/showKosten';
import { findKennziffernSpeziell, getKennziffernSpeziell } from './speziell/getKennziffernSpeziell';
import { fn0nZ, fn2nZ } from '../../core/formatter/formatNumber';
import { getRoutingEnergiedaten } from '../../helpers/getRoutingEnergiedaten';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { hasKennzahlenSpez } from './speziell/getKennziffernSpeziell';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { rowHasValues } from './generisch/renderRows';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';

interface DatenauswertungEnergiekennzahlenSpezProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortTid: number;
    standortName: string;
    mode: string;
    jahrFirst?: number;
    jahrLast?: number;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
}

interface DatenauswertungEnergiekennzahlenSpezState {
    pdfString?: string;
    firstJahr: number;
    lastJahr: number;
    jahrMin: number;
    jahrMax: number;
    renderButton: JSX.Element;
}

export class DatenauswertungEnergiekennzahlenSpez extends
    React.Component<DatenauswertungEnergiekennzahlenSpezProps, DatenauswertungEnergiekennzahlenSpezState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        this.state = {
            lastJahr: this.props.jahrLast || jahrMax - 1,
            firstJahr: this.props.jahrFirst || jahrMin,
            jahrMin: jahrMin,
            jahrMax: jahrMax,
            renderButton: undefined
        };
    }

    private style: any = { sub: getStyle('sub') };

    getValues(kuerzel: string[]): any {
        const rows: any[] = [];
        const diag1: any[] = [];
        const diag2: any[] = [];
        const kennzahlen = this.props.standortTid
            ? this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standortTid]
            : this.props.data[IDs.KENNZIFFERN_BERECHNET];
        // console.log('DEBUG KZ', kennzahlen);
        for (let jahr = this.state.firstJahr; jahr <= this.state.lastJahr; jahr++) {
            let strom_val: number = undefined;
            let waerme_val: number = undefined;
            let kraftstoff_val: number = undefined;
            if (this.props.mode === 'verbrauch') {
                strom_val = kennzahlen[jahr] && kennzahlen[jahr].strom_verbrauch_gesamt ? kennzahlen[jahr].strom_verbrauch_gesamt : 0;
                waerme_val = kennzahlen[jahr] && kennzahlen[jahr].waerme_kwh ? kennzahlen[jahr].waerme_kwh : 0;
                kraftstoff_val = kennzahlen[jahr] && kennzahlen[jahr].kraftstoff_kwh ? kennzahlen[jahr].kraftstoff_kwh : 0;
            } else if (this.props.mode === 'kosten') {
                strom_val = kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt ? kennzahlen[jahr].strom_kosten_gesamt : 0;
                waerme_val = kennzahlen[jahr] && kennzahlen[jahr].kosten_waerme ? kennzahlen[jahr].kosten_waerme : 0;
                kraftstoff_val = kennzahlen[jahr] && kennzahlen[jahr].kraftstoffe_kosten ? kennzahlen[jahr].kraftstoffe_kosten : 0;
            }
            const gesamt_val = strom_val + waerme_val + kraftstoff_val;
            const row = this.props.mode === 'verbrauch'
                ? [jahr, fn0nZ(strom_val), fn0nZ(waerme_val), fn0nZ(kraftstoff_val), fn0nZ(gesamt_val)]
                : [jahr, fn2nZ(strom_val), fn2nZ(waerme_val), fn2nZ(kraftstoff_val), fn2nZ(gesamt_val)];

            kuerzel.forEach((k: string, idx: number) => {
                const val = kennzahlen[jahr] && kennzahlen[jahr][k] ? kennzahlen[jahr][k] : 0;
                const val2 = val > 0 ? gesamt_val / val : 0;
                row.push(fn2nZ(val));
                row.push(fn2nZ(val2));
                const d = { jahr, wert: val2 };

                if (idx === 0 && val2) {
                    diag1.push(d);
                } else if (idx === 1 && val2) {
                    diag2.push(d);
                }
            });

            if (rowHasValues(row)) {
                rows.push(row);
            }
        }
        return { rows, diag1, diag2 };
    }

    render(): JSX.Element {
        const kenn_def = findKennziffernSpeziell(this.props.data, this.props.mode);
        const numCols = 5 + (kenn_def ? kenn_def.length * 2 : 0);
        const baseWidth = 100 / numCols; // = 7.69% Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const kennziffernSpeziell = getKennziffernSpeziell(kenn_def, baseWidth, this.props.mode);
        const values = this.getValues(kennziffernSpeziell.kuerzel);

        if (values.diag1 && kennziffernSpeziell.diags && kennziffernSpeziell.diags[0]) {
            kennziffernSpeziell.diags[0].data = values.diag1;
        }

        if (values.diag2 && kennziffernSpeziell.diags && kennziffernSpeziell.diags[1]) {
            kennziffernSpeziell.diags[1].data = values.diag2;
        }
        const einheit = this.props.mode === 'verbrauch' ? 'kWh' : `€ (${i18n('netto', 'sys')})`;
        const config: any = {
            titel0: unternehmen,
            titel1: `${i18n('Energiekennzahlen', 'sys')} (${i18n('spezifisch', 'sys')})`,
            titel2: this.props.standortName,
            filename: `${i18n('Energiekennzahlen', 'sys')}_${i18n('spezifisch', 'sys')}_${this.state.firstJahr}_${this.state.lastJahr}.pdf`,
            report: {
                data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'energiekennzahlen',
                sub: `spez_${this.props.mode}`
            },
            baseWidth: baseWidth,
            header: {
                title: i18n('Übersicht Berechnung', 'sys'),
                blocks: [
                    {
                        label: i18n('Jahr', 'sys'),
                        width: `${baseWidth}%`
                    },
                    {
                        label: i18n(`Energie${this.props.mode === 'verbrauch' ? 'einsatz' : this.props.mode}`, 'sys'),
                        width: `${baseWidth * 4}%`,
                        columns: [
                            { label: i18n('Strom', 'sys'), label2: einheit, customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Wärme', 'sys'), label2: einheit, customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Kraftstoff', 'sys'), label2: einheit, customStyleLabel2: { borderTop: '1pt solid #fff' } },
                            { label: i18n('Gesamt', 'sys'), label2: einheit, customStyleLabel2: { borderTop: '1pt solid #fff' } }
                        ]
                    },
                    ...kennziffernSpeziell.blocks
                ]
            },
            rows: values.rows,
            row_classes: ['row_field_header', , , , 'row_field_dark', , 'row_field_dark', , 'row_field_dark'],
            diagrams: kennziffernSpeziell.diags
        };
        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'inline-block' }}
                styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey={`datenauswertung_energiekennzahlen_speziell_${this.props.mode}`}
                type='info'
                editBar
            />
        );
        const jahresauswahl: any = <DatenauswertungJahrauswahl
            jahrMin={this.state.jahrMin}
            jahrMax={this.state.jahrMax}
            jahrFirst={this.state.firstJahr}
            jahrLast={this.state.lastJahr}
            contextKey='datenauswertung'
            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
            renderClean={true}
            wrapClass={datenauswertungStyle.datenauswertungFormField}
        />;
        const arr_header_form_elements: any[] = [
            {
                elem: jahresauswahl,
                wrapClass: 'datenauswertungContentLeft',
                skipFormFieldWrapper: true
            },
            {   elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={datenauswertungStyle.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
        ];
        return (
            <div>
                {!this.props.setJSXdirect &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        {/*<DatenauswertungJahrauswahl
                            jahrMin={this.state.jahrMin}
                            jahrMax={this.state.jahrMax}
                            jahrFirst={this.state.firstJahr}
                            jahrLast={this.state.lastJahr}
                            contextKey='datenauswertung'
                            externalHeaderElements={[this.renderEingabeButton(), this.renderBemerkungButton(), this.state.renderButton]}
                            onFirstJahrChange={(jahr: number) => this.setState({ firstJahr: jahr })}
                            onLastJahrChange={(jahr: number) => this.setState({ lastJahr: jahr })}
                        />
                        <div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div>
                        */}
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    config={config}
                    orientation='landscape'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ backgroundColor: '#686868', color: '#fff' }}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='energiekennzahlen'
                sub={`spez_${this.props.mode}`}
                styleProps={{ backgroundColor: '#686868', color: '#fff' }}
                noLabel={true}
            />
        );
    }

    renderEingabeButton(): JSX.Element {
        const entities: string[] = [IDs.ENT_KENNZIFFERN_GENERATED];
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingEnergiedaten(this.props.data, this.props.standortTid, entities) || {})
                })}
            />
        );
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        const hasKennzahlen: boolean = hasKennzahlenSpez(this.props.data, this.props.mode, standort.tid);
                        callback(
                            (!!flags.hasKraftstoffe || !!flags.hasWaerme || !!flags.hasStrom)
                            && hasKennzahlen
                            && (this.props.mode === 'verbrauch' || (this.props.mode === 'kosten' && !disableKosten(this.props.data)))
                        );
                        // callback((!!flags.hasKraftstoffe || !!flags.hasWaerme || !!flags.hasStrom) && !disableKosten(this.props.data));
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({
                        path: {
                            ...(this.props.mode === 'kosten'
                                ? RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_KOSTENBEZOGEN_SPEZ
                                : (this.props.mode === 'verbrauch' ? RoutingIDs.ROUTE_ENERGIEKENNZAHLEN_VERBRAUCHSBEZOGEN_SPEZ : {})
                            ),
                            ...path,
                        }
                    });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }
}
